export default __webpack_public_path__ + "static/commentTransformerUneRobeEnCombishort.1-906afeeac819815bf1eff9c47cd5f251.jpg";